import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductListingPage/index.js";
const variants = import.meta.webpackContext("/components/ProductListingPage", { recursive: true, regExp: /\.\/__variants__\/plp\-face\-and\-body\-carousel\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });